import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { IndicatorGet, IndicatorVariableGet, LOGIC_FUNCTIONS, LOGIC_OPERATIONS } from '../../../../../core/interfaces/sales-engine-interfaces';
import { SalesEngineDataService } from '../../../../../core/services/sales-engine-data.service';

export enum FormulaMenuTab {
  INDICATORS = 0,
  VARIABLES = 1,
  FUNCTIONS = 2,
}
interface TabItem {
  id: FormulaMenuTab;
  label: string;
}

@Component({
  selector: 'app-formula-input-box',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, FormsModule],
  templateUrl: './formula-input-box.component.html',
  styleUrl: './formula-input-box.component.css'
})
export class FormulaInputBoxComponent {
  constructor(private salesEngineData: SalesEngineDataService) { }

  @ViewChild('formulaRef') formulaRef!: ElementRef<HTMLTextAreaElement>;

  @Input() formula: string = '';
  @Output() formulaChange = new EventEmitter<string>();

  showFuncMenu = false;
  triggerIndex: number | null = null;
  logicFuncs = LOGIC_FUNCTIONS;
  logicOperations = LOGIC_OPERATIONS;

  // Tabs
  FormulaMenuTab = FormulaMenuTab;

  tabs: TabItem[] = [
    { id: FormulaMenuTab.INDICATORS, label: 'admin.indicators' },
    { id: FormulaMenuTab.VARIABLES, label: 'admin.variables' },
    { id: FormulaMenuTab.FUNCTIONS, label: 'admin.functions' },
  ];

  selectedTabId: FormulaMenuTab = FormulaMenuTab.FUNCTIONS;

  indicators: IndicatorGet[] = this.salesEngineData.getIndicators();
  variables: IndicatorVariableGet[] = this.salesEngineData.getSystemVariables();

  get functionsHint(): string {
    return this.logicOperations.map(f => f.label).join(', ');
  }

  onKeydown(e: KeyboardEvent) {
    if (e.key === '#') {
      setTimeout(() => {
        const ta = this.formulaRef.nativeElement;
        this.triggerIndex = ta.selectionStart - 1;
        this.showFuncMenu = true;

        this.indicators = this.salesEngineData.getIndicators();
        this.variables = this.salesEngineData.getSystemVariables();
      });
    } else if (e.key === 'Escape') {
      this.closeMenu();
    }
  }

  insertFunction(item: string) {
    if (this.triggerIndex == null) return;
    const start = this.triggerIndex;
    const end = start + 1;
    const before = this.formula.slice(0, start);
    const after = this.formula.slice(end);
    this.formula = before + `#${item}` + after;
    this.formulaChange.emit(this.formula);

    setTimeout(() => {
      const ta = this.formulaRef.nativeElement;
      ta.focus();
      const caret = start + item.length;
      ta.selectionStart = ta.selectionEnd = caret;
    });

    this.closeMenu();
  }

  closeMenu() {
    this.showFuncMenu = false;
    this.triggerIndex = null;
  }

  @HostListener('document:click', ['$event'])
  onDocClick(ev: MouseEvent) {
    const target = ev.target as HTMLElement;
    const box = this.formulaRef?.nativeElement?.parentElement;
    if (box && !box.contains(target)) this.closeMenu();
  }

  selectTab(id: FormulaMenuTab) {
    this.selectedTabId = id;
  }
  trackById = (_: number, tab: TabItem) => tab.id;
}
